import { GoogleMap, Marker } from '@react-google-maps/api';
import React from 'react';
import { baseSize, getIcon } from "../../Helpers/map";
export var CustomMap = function CustomMap(_ref) {
  var mapLocations = _ref.mapLocations,
    fallback = _ref.fallback,
    mapCenter = _ref.mapCenter,
    containerStyle = _ref.containerStyle,
    staticAssetsHost = _ref.staticAssetsHost,
    siteCode = _ref.siteCode,
    zoom = _ref.zoom;
  var _a, _b, _c;
  var mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    gestureHandling: 'cooperative'
  };
  var basePin = {
    size: new google.maps.Size(baseSize.width, baseSize.height),
    scaledSize: new google.maps.Size(baseSize.width, baseSize.height),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(baseSize.width / 2, baseSize.height / 2)
  };
  var iconInfo = Object.assign(Object.assign({}, basePin), {
    url: "".concat(staticAssetsHost).concat(getIcon(siteCode))
  });
  return (mapLocations === null || mapLocations === void 0 ? void 0 : mapLocations.length) > 0 ? /*#__PURE__*/React.createElement(GoogleMap, {
    mapContainerStyle: containerStyle,
    center: mapCenter,
    zoom: zoom,
    options: mapOptions
  }, (_a = mapLocations === null || mapLocations === void 0 ? void 0 : mapLocations.map) === null || _a === void 0 ? void 0 : _a.call(mapLocations, function (location) {
    return /*#__PURE__*/React.createElement(Marker, {
      key: "".concat(location.lat, "_").concat(location.lng),
      position: location,
      icon: iconInfo
    });
  })) : /*#__PURE__*/React.createElement(GoogleMap, {
    mapContainerStyle: containerStyle,
    center: fallback === null || fallback === void 0 ? void 0 : fallback.mapCenter,
    zoom: fallback === null || fallback === void 0 ? void 0 : fallback.zoom,
    options: mapOptions
  }, (_c = (_b = fallback === null || fallback === void 0 ? void 0 : fallback.mapLocations) === null || _b === void 0 ? void 0 : _b.map) === null || _c === void 0 ? void 0 : _c.call(_b, function (location) {
    return /*#__PURE__*/React.createElement(Marker, {
      key: "".concat(location.lat, "_").concat(location.lng),
      position: location,
      icon: iconInfo
    });
  }));
};